<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CCard>
          <EventHeader :event="event" @edit-event="editEvent"/>

          <EventTabs :activeTab="activeTab" @change="onTabChange" :event="event" :blacklistCount="blacklistCount"/>

          <CCardBody>
            <GuestsModule v-if="activeTab === 'guests'" :event="event" @open-scheduled-modal="openScheduledModal" />

            <ScheduledSendsModule ref="scheduledSendsModule" :event="event" :is-active="activeTab === 'scheduled'" @saved-scheduled-send="handleScheduledSaved" />

            <HistoryModule v-if="activeTab === 'history'" :event="event" />

            <BlacklistModule v-if="activeTab === 'blacklist' && blacklistCount > 0" :event="event" />
          </CCardBody>
        </CCard>

      </CCol>
    </CRow>
    <EventModal ref="eventModal" @update="updateProcess"></EventModal>
  </div>
</template>

<script>
import EventHeader from '@/components/events/event/detail/EventHeader.vue'
import EventTabs from '@/components/events/event/detail/EventTabs.vue';
import GuestsModule from '@/components/events/event/detail/guests/GuestsModule.vue';
import ScheduledSendsModule from '@/components/events/event/detail/scheduled/ScheduledSendsModule.vue';
import HistoryModule from '@/components/events/event/detail/history/HistoryModule.vue';
import BlacklistModule from '@/components/events/event/detail/blacklist/BlacklistModule.vue';
import EventModal from '@/components/events/EventModal.vue';
import ws_event from '@/services/events';
import ws_guests from '@/services/events_guests';
import store from '@/store';

export default {
  name: 'EventDetail',
  components: { EventHeader, EventTabs, GuestsModule, ScheduledSendsModule, EventModal, HistoryModule, BlacklistModule },
  data: function () {
    return {
      guests: [],
      event_id: this.$route.params.id,
      event: {},
      activeTab: 'guests',
      blacklistCount: 0
    }
  },
  mounted: async function () {
    this.loading();
    await this.getEvent();
    await this.getBlacklistCount();
    this.applyTabFromRoute();

    this.loaded();
  },
  watch: {
    '$route.query.tab'() {
      this.applyTabFromRoute();
    }
  },
  methods: {
    allowedTabs() {
      return ['guests', 'scheduled', 'history', 'blacklist'];
    },
    applyTabFromRoute() {
      const requestedTab = String(this.$route.query.tab || '').trim();
      const tab = this.allowedTabs().includes(requestedTab) ? requestedTab : 'guests';

      if (tab === 'blacklist' && this.blacklistCount === 0) {
        this.activeTab = 'guests';
        return;
      }

      this.activeTab = tab;
    },
    onTabChange(tab) {
      const normalizedTab = this.allowedTabs().includes(tab) ? tab : 'guests';
      this.activeTab = normalizedTab;

      const query = normalizedTab === 'guests' ? {} : { tab: normalizedTab };
      this.$router.replace({ query });
    },
    openScheduledModal(messageType = null) {
      if (this.$refs.scheduledSendsModule) {
        this.$refs.scheduledSendsModule.openCreateFromOutside(messageType)
      }
    },
    handleScheduledSaved() {
      if (this.activeTab !== 'scheduled') {
        this.activeTab = 'scheduled'
      }
    },
    async editEvent() {
      this.$refs.eventModal.updateModal(this.event);
    },
    async getEvent() {
      let response_event = await ws_event.show(this.event_id);
      if (response_event.type == "success") {
        this.event = response_event.data;
      }
    },
    async getBlacklistCount() {
      const response = await ws_guests.getBlacklist({ event_id: this.event_id });
      if (response.type === 'success') {
        this.blacklistCount = response.data.length;

        if (this.blacklistCount === 0 && this.activeTab === 'blacklist') {
          this.activeTab = 'guests';
          this.$router.replace({ query: {} });
        }
      }
    },
    async updateProcess(data) {
      this.loading();
      let response = await ws_event.update(data);

      if (response.type == "success") {
        await this.getEvent();
        await this.getBlacklistCount();
      }

      this.showToast(response.type, response.message);
      this.loaded();
    },
    showToast(type, message) {
      store.commit('toast', { color: type, message: message });
    },
    loading() {
      store.commit('loading');
    },
    loaded() {
      store.commit('loaded');
    }
  }
}
</script>
